import React from "react";
import Section from "./section";
import { IRealtimeData } from "../../../../types";
import RtValue from "./rtValue";
import { IRightPaneCodes } from "./types";

interface IProps {
  realtime:  Record<string, IRealtimeData>;
}

const codes: IRightPaneCodes = {
  superHeat: {
    value: "MS.CASTER1.AUTO_SUPER_HEAT",
    min: "MS.CASTER1.N2.SUPER_HEAT_MIN",
    max: "MS.CASTER1.N2.SUPER_HEAT_MAX",
    aim: "MS.CASTER1.N2.SUPER_HEAT_AIM",
  },
  turretArmWeight: "MS.CASTER1.TURRET.ARM_IN_CAST_WEIGHT",
  speed: "MS.CASTER1.N2.SUPER_HEAT_SPEED_GOAL",
  liquidusTemperature: "MS.CASTER1.QA.N2.SUPER_HEAT_LIQUIDUS_TEMPERATURE",
  tundish: {
    temperature: "MS.CASTER1.TUNDISH.STEEL_TEMPERATURE",
    netWeight: "MS.CASTER1.TUNDISH.NET_WEIGHT"
  }
};

const RightPane = ({ realtime }: IProps) => {

  return (
    <Section level={0}>
      <div className="display-grid" style={{ gridTemplateColumns: "1fr 1fr", gridTemplateRows: "auto auto auto" }}>
        <RtValue orientation="vertical" title="Super Heat" rtValue={realtime[codes.superHeat.value]}
                 style={{ color: "yellow", textAlign: "center", fontSize: "2em" }} />
        <div className="display-grid" style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
          <RtValue orientation="vertical" title="MIN" rtValue={realtime[codes.superHeat.min]}
                   style={{ color: "red", textAlign: "center" }} />
          <RtValue orientation="vertical" title="AIM" rtValue={realtime[codes.superHeat.aim]}
                   style={{ color: "lightyellow", textAlign: "center" }} />
          <RtValue orientation="vertical" title="MAX" rtValue={realtime[codes.superHeat.max]}
                   style={{ color: "red", textAlign: "center" }} />
        </div>
        <RtValue orientation="vertical" title="Turret Arm in Cast Weight" rtValue={realtime[codes.turretArmWeight]}
                 style={{ color: "magenta", textAlign: "center", fontSize: "2em" }} />
        <RtValue orientation="vertical" title="Tundish Net Weight" rtValue={realtime[codes.tundish.netWeight]}
                 style={{ textAlign: "center", fontSize: "2em" }} />
        <RtValue orientation="vertical" title="Liquidus Temperature" rtValue={realtime[codes.liquidusTemperature]}
                 style={{ color: "cyan", textAlign: "center", fontSize: "2em" }} />
        <RtValue orientation="vertical" title="Tundish Temperature" rtValue={realtime[codes.tundish.temperature]}
                 style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
      </div>
    </Section>
  );
}

export default RightPane;